/**
 * A light haptic tick, where the device will give one.
 *
 * Android Chrome has navigator.vibrate. iOS Safari has no haptics API at all,
 * but since Safari 18 toggling a native switch (<input type="checkbox" switch>)
 * plays the system's selection haptic — so a hidden one, clicked through its
 * label, is how web apps get the tick native tab bars make. It is a workaround,
 * not an API: it needs to run inside a touch handler, it follows the phone's
 * own Settings › Sounds & Haptics › System Haptics, and on anything else it
 * quietly does nothing.
 */

export function hapticTick(): void {
  try {
    if (typeof navigator !== "undefined" && typeof navigator.vibrate === "function") {
      navigator.vibrate(8);
      return;
    }
    const label = document.createElement("label");
    label.setAttribute("aria-hidden", "true");
    label.style.display = "none";
    const input = document.createElement("input");
    input.type = "checkbox";
    input.setAttribute("switch", "");
    label.appendChild(input);
    document.head.appendChild(label);
    label.click();
    label.remove();
  } catch {
    /* no haptics here — nothing to do */
  }
}
